import { createContext, SetStateAction, Dispatch } from 'react';

import { FormInstance } from 'antd';

import { QuotationButton } from '../../../../../shared';

import { ConsortiumPaymentMethodForm, ConsortiumQuotationForm } from './StepThreeFormProvider';
import { ConsortiumQuotationComponent, ConsortiumQuotationRequest, GetCommertialsConditionsResponse } from '../../../../../../../../../shared/interfaces';

interface StepThreeFormContextProps {
    canQuote:                               boolean;
    clearPrimaFieldsOnFormChange:           () => void;
    commertialConditions:                   GetCommertialsConditionsResponse | undefined;
    consortiumPaymentMethodsForm:           FormInstance<ConsortiumPaymentMethodForm>;
    consortiumQuotationComponents:          Array<ConsortiumQuotationComponent>;
    createTabs:                             () => void;
    generateConsortiumQuotationForm:        () => ConsortiumQuotationRequest;
    isLoadingForm:                          boolean;
    labelButton:                            QuotationButton;
    quotationResponse:                      any | undefined;
    quotationTabs:                          any;
    setCanQuote:                            Dispatch<boolean>;
    setIsLoadingForm:                       Dispatch<SetStateAction<boolean>>;
    setLabelButton:                         Dispatch<SetStateAction<QuotationButton>>;
    setQuotationResponse:                   Dispatch<SetStateAction<any | undefined>>;
    stepThreeConsortiumQuotationForm:       FormInstance<ConsortiumQuotationForm>;
    tabsThree:                              any | undefined;
    canCreateTabThree:                      boolean;
    activeTab:                              any;
    setActiveTab:                           Dispatch<any>;
    handlerOnClick:                         () => void;
}

export const StepThreeFormContext = createContext({} as StepThreeFormContextProps);